/* unplugin-vue-components disabled */import { ElInput as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElCard as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/card/style/css';
import { ElTag as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/tag/style/css';
import { ElButton as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElSelect as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElAlert as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/alert/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-718b8360"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "flex items-center marginT10"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "无法启动游戏的地区：", -1));
const _hoisted_3 = {
  key: 0,
  class: "region-box"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createTextVNode("黑白名单限制 "), /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#faad14",
    "font-size": "12px"
  }
}, "注: 多个IP地址请使用英文','分隔")], -1));
const _hoisted_5 = {
  class: "flex"
};
const _hoisted_6 = {
  class: "flex items-center justify-between marginT10"
};
const _hoisted_7 = {
  class: "label"
};
const _hoisted_8 = {
  class: "marginT10 marginB10"
};
const _hoisted_9 = {
  class: "flex items-center marginT10 marginB10"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, [/*#__PURE__*/_createTextVNode("URL白名单 "), /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#F79E13",
    "font-size": "12px"
  }
}, " 在限制登录游戏的情况下，下述登录之前的接口可走白名单通道被调试，例如初始化等接口，该功能一般由研发人员使用！ ")], -1));
import { apiUsdkGetRegionList, apiUsdkIpLimitDetail, apiUsdkUpdateIpLimit } from '@/api/usdk';
import { useAppStore } from '@/store/modules/app';
export default /*#__PURE__*/_defineComponent({
  __name: 'loginWhite',
  setup(__props) {
    const gameInfo = computed(() => useAppStore().gameInfo);
    const editArea = ref(false);
    const editUrl = ref(false);
    const areas = ref([]);
    const regionList = ref([]);
    const allowUrl = ref('');
    const ipList = ref([{
      msg: 'IP白名单下可正常登录游戏！',
      type: 'success',
      key: 'allowIp',
      label: 'IP白名单',
      content: '',
      placeholder: '请输入IP白名单',
      isEdit: false
    }, {
      msg: 'IP黑名单下将无法登录游戏！',
      type: 'warning',
      key: 'denyIp',
      label: 'IP黑名单',
      content: '',
      placeholder: '请输入IP黑名单',
      isEdit: false
    }, {
      msg: '被添加的角色账号ID可正常登录游戏',
      type: 'success',
      key: 'allowSuid',
      label: '角色账号ID白名单',
      content: '',
      placeholder: '请输入角色账号ID白名单',
      isEdit: false
    }]);
    const handleSave = (type, data) => {
      let params = {};
      if (type === 'area') {
        console.log('areas', areas);
        params.denyArea = areas.value.length > 0 ? areas.value.join(',') : '-1';
      } else if (type === 'url') {
        params.allowUrl = allowUrl.value || '-1';
      } else {
        const content = data.content && data.content.replace(/[\n\t\s，]/g, ',');
        const reg = /^(((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3},?)+$/;
        if (type !== 'allowSuid' && content && !reg.test(content)) {
          ElMessage.warning('填写格式不合规，多个 ip 地址请使用英文符号‘,’进行分割，不要加入其他符号');
          return;
        }
        params[data.key] = content || '-1';
        data.content = content;
      }
      apiUsdkUpdateIpLimit({
        gid: gameInfo.value.Id,
        ...params
      }).then(res => {
        if (res.code === 0) {
          if (type === 'area') {
            editArea.value = false;
          } else if (type === 'url') {
            editUrl.value = false;
          } else {
            data.isEdit = false;
          }
        }
      });
    };
    const handleCloseRegion = (e, index) => {
      e.preventDefault();
      areas.value.splice(index, 1);
    };
    const getRegionList = async () => {
      await apiUsdkGetRegionList({
        gid: gameInfo.value.Id
      }).then(res => {
        if (res.code === 0) {
          regionList.value = res.data;
          getDetail();
        }
      });
    };
    const getDetail = () => {
      apiUsdkIpLimitDetail({
        gid: gameInfo.value.Id
      }).then(res => {
        if (res.code === 0) {
          if (res.data.denyArea) {
            regionList.value.forEach(item => {
              if (res.data.denyArea.includes(item.code)) {
                areas.value.push(item.name);
              }
            });
          }
          allowUrl.value = res.data.allowUrl;
          ipList.value.forEach(item => {
            item.content = res.data[item.key];
          });
        }
      });
    };
    watch(() => gameInfo.value, val => {
      if (val && val.Id) {
        getRegionList();
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_alert = __unplugin_components_0;
      const _component_el_option = __unplugin_components_1;
      const _component_el_select = __unplugin_components_2;
      const _component_el_button = __unplugin_components_3;
      const _component_el_tag = __unplugin_components_4;
      const _component_el_card = __unplugin_components_5;
      const _component_el_input = __unplugin_components_6;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_card, {
        shadow: "never",
        header: "地区限制"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_alert, {
          title: "下述地区将无法登录本游戏！",
          type: "warning",
          "show-icon": "",
          closable: false
        }), _createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_select, {
          clearable: "",
          multiple: "",
          modelValue: _unref(areas),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(areas) ? areas.value = $event : null),
          disabled: !_unref(editArea),
          placeholder: "选择地区",
          style: {
            "min-width": "400px"
          }
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(regionList), item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.code,
              value: item.code,
              label: item.name
            }, null, 8, ["value", "label"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "disabled"]), !_unref(editArea) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          class: "marginL10",
          type: "primary",
          onClick: _cache[1] || (_cache[1] = $event => {
            editArea.value = true;
          })
        }, {
          default: _withCtx(() => [_createTextVNode("编辑")]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          class: "marginL10",
          type: "primary",
          onClick: _cache[2] || (_cache[2] = $event => handleSave('area'))
        }, {
          default: _withCtx(() => [_createTextVNode("保存")]),
          _: 1
        }))]), _unref(areas).length ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(areas), (item, index) => {
          return _openBlock(), _createBlock(_component_el_tag, {
            class: "marginL10",
            type: "danger",
            key: index,
            closable: _unref(editArea),
            onClose: $event => handleCloseRegion($event, index)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
            _: 2
          }, 1032, ["closable", "onClose"]);
        }), 128))])) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never",
        class: "marginT20"
      }, {
        header: _withCtx(() => [_hoisted_4]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ipList), (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(['flex-1', index > 0 ? 'marginL30' : ''])
          }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(item.label) + ":", 1), !item.isEdit ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            size: "small",
            type: "primary",
            onClick: $event => item.isEdit = true
          }, {
            default: _withCtx(() => [_createTextVNode("编辑")]),
            _: 2
          }, 1032, ["onClick"])) : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            class: "marginL10",
            size: "small",
            type: "primary",
            onClick: $event => handleSave(item.key, item)
          }, {
            default: _withCtx(() => [_createTextVNode("保存")]),
            _: 2
          }, 1032, ["onClick"]))]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_input, {
            type: "textarea",
            disabled: !item.isEdit,
            modelValue: item.content,
            "onUpdate:modelValue": $event => item.content = $event,
            placeholder: item.placeholder,
            autosize: {
              minRows: 10,
              maxRows: 10
            }
          }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "placeholder"])]), _createVNode(_component_el_alert, {
            title: item.msg,
            type: item.type,
            "show-icon": ""
          }, null, 8, ["title", "type"])], 2);
        }), 128))])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never",
        class: "marginT20"
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_9, [_hoisted_10, !_unref(editUrl) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          size: "small",
          type: "primary",
          onClick: _cache[3] || (_cache[3] = $event => editUrl.value = true)
        }, {
          default: _withCtx(() => [_createTextVNode("编辑")]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          size: "small",
          type: "primary",
          onClick: _cache[4] || (_cache[4] = $event => handleSave('url'))
        }, {
          default: _withCtx(() => [_createTextVNode("保存")]),
          _: 1
        }))]), _createVNode(_component_el_input, {
          type: "textarea",
          disabled: !_unref(editUrl),
          modelValue: _unref(allowUrl),
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(allowUrl) ? allowUrl.value = $event : null),
          autosize: {
            minRows: 3,
            maxRows: 5
          },
          placeholder: "请输入URL白名单，用,分割"
        }, null, 8, ["disabled", "modelValue"])])]),
        _: 1
      })], 64);
    };
  }
});